module.exports = __webpack_public_path__ + "img/jadsticky.7326a5bd.svg";